{#if either href link}
  <a href={href} target={target} class="hitbox">
    {>content}
  </a>
{else}
  {> content}
{/if}

{#snippet content}
  <i class="{uiClasses}icon{maybeCustomIcon}" style={getIconStyle} part="icon"></i>
{/snippet}
